import PropTypes from 'prop-types';
function TeacherStatsDonorsChooseHistory({ numMonthsActive, lifetimeFullyFundedProjects }) {
    function timeWithDonorsChoose() {
        const years = Math.floor(numMonthsActive / 12);
        if (years) {
            if (numMonthsActive % 12 === 0) {
                return `${years} year${years > 1 ? 's' : ''}`;
            }
            return `${years} yr & ${numMonthsActive % 12} mos`;
        }
        return `${numMonthsActive % 12} month${numMonthsActive > 1 ? 's' : ''}`;
    }
    function fundedTrophy() {
        if (lifetimeFullyFundedProjects === 0) return null;
        return (

            <section className='projectsFunded'>
                <div aria-label='trophy graphic' className='illustration trophy'></div>
                <div className='lifeTimeFunded'>
                    <h2>{lifetimeFullyFundedProjects}</h2>
                </div>
                <h3>Projects funded</h3>
            </section>
        );
    }
    function addDivider() {
        if (lifetimeFullyFundedProjects === 0) return null;
        return (
            <section className='divider'></section>

        );
    }

    return (
        <section className='dc-overview-row'>
            <section className='time-with-wrapper'>
                <div aria-label='calendar graphic' className='illustration calendar'></div>
                <div className='time-with'>
                    <h2>{timeWithDonorsChoose()}</h2>
                </div>
                <h3>with DonorsChoose</h3>
            </section>

            {addDivider()}
            {fundedTrophy()}
        </section>);
}

TeacherStatsDonorsChooseHistory.propTypes = {
    numMonthsActive: PropTypes.number.isRequired,
    lifetimeFullyFundedProjects: PropTypes.number.isRequired,
};

export default TeacherStatsDonorsChooseHistory;
